import { Injectable } from '@angular/core';
import { PassportProduct } from '@app/core/interfaces';
import { InsurancePolicyDataService, PurchasedProductInterface } from 'outshared-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { passportProductsData } from './passport-products.data';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Injectable({
    providedIn: 'root',
})
export class PassportService {
    constructor(private insurancePolicyDataService: InsurancePolicyDataService) {}

    public getPassportProducts$(): Observable<PassportProduct[]> {
        return this.insurancePolicyDataService.getPurchasedProducts$().pipe(
            map((purchasedProducts) => this.mapPurchasedProducts(purchasedProducts)),
            map((allProducts) => this.sortAllProductsByRank(allProducts)),
            map((allProducts) => this.sortAllProductsByPurchased(allProducts))
        );
    }

    private mapPurchasedProducts(purchasedProducts: PurchasedProductInterface[]): PassportProduct[] {
        return passportProductsData.map((passportProduct: PassportProduct) => {
            const purchasedProduct = purchasedProducts.find(
                (_purchasedProduct) => _purchasedProduct.productId === passportProduct.productId
            );

            passportProduct.purchased = purchasedProduct ? 1 : 0;

            if (purchasedProduct) {
                passportProduct.productSequenceNumber = purchasedProduct.productSequenceNumber;
            }

            return passportProduct;
        });
    }

    private sortAllProductsByRank(passportProducts: PassportProduct[]): PassportProduct[] {
        return passportProducts.sort((a, b) => {
            if (a.productRank < b.productRank) {
                return -1;
            }
            if (a.productRank > b.productRank) {
                return 1;
            }
            return 0;
        });
    }

    private sortAllProductsByPurchased(passportProducts: PassportProduct[]): PassportProduct[] {
        return passportProducts.sort((a, b) => b.purchased - a.purchased);
    }
}
